import get from '../../utils/http-utils'



export function getStatus() {
    return get("/lookup/status")
        .then(resp => {
            const status = Object.values(resp.data).reduce((acc, val, ind) => {
                let tempObj = { key: val, value: val }
                acc.push(tempObj)
                return acc;
            }, [])
            return { data: status }

        }, err => {
            return { error: err.message };
        })
}

export function getSWVersions() {
    return get("/lookup/swversions")
        .then(resp => {
            const swVersions = Object.values(resp.data).reduce((acc, val, ind) => {
                let tempObj = { key: val, value: val }
                acc.push(tempObj)
                return acc;
            }, [])
            return { data: swVersions }

        }, err => {
            return { error: err.message };
        })
}